export const DEFAULT_AGENT_TIMEZONE = 'Europe/Madrid'

const FALLBACK_TIMEZONES = [
  DEFAULT_AGENT_TIMEZONE,
  'UTC',
  'Europe/London',
  'America/Argentina/Buenos_Aires',
  'America/Bogota',
  'America/Mexico_City',
  'America/New_York',
  'America/Los_Angeles',
  'Asia/Dubai',
  'Asia/Tokyo',
] as const

function uniqueTimezones(values: readonly string[]): string[] {
  return Array.from(new Set(values.map((value) => value.trim()).filter(Boolean)))
}

export function getAvailableTimezones(): string[] {
  const intlWithSupportedValues = Intl as typeof Intl & {
    supportedValuesOf?: (key: string) => string[]
  }

  const dynamicValues = (() => {
    try {
      return intlWithSupportedValues.supportedValuesOf?.('timeZone') ?? []
    } catch {
      return []
    }
  })()

  const merged = uniqueTimezones([...FALLBACK_TIMEZONES, ...dynamicValues])
  return merged.sort((left, right) => {
    if (left === DEFAULT_AGENT_TIMEZONE) return -1
    if (right === DEFAULT_AGENT_TIMEZONE) return 1
    if (left === 'UTC') return -1
    if (right === 'UTC') return 1
    return left.localeCompare(right)
  })
}
